module.exports = __webpack_public_path__ + "static/media/AB_K17_4.802810f7.jpg";